import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import AccessDeniedPage from '../ui/AccessDeniedPage';

/**
 * <RoleGuard roles={['ADMIN']} depts={['FINANCE']} children={...} />
 * - If unauthenticated → redirect /login
 * - If authenticated but missing role/dept → AccessDeniedPage
 * - SUPERADMIN always passes department checks
 */
export default function RoleGuard({ roles, depts, anyOf, children }) {
  const { isAuthenticated, can } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const requires = anyOf ? { anyOf } : { roles, depts };
  if (!can(requires)) {
    return <AccessDeniedPage requires={{ roles, depts }} />;
  }
  return children;
}
